import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Input from '../../../../Atoms/Input';
import TextArea from '../../../../Atoms/TextArea';
import ButtonMain from '../../../../Atoms/ButtonMain';
import ButtonSecondary from '../../../../Atoms/ButtonSecondary';
import './styles.css';

export default function EditIdeaModal({ 
    show, 
    onHide, 
    idea, 
    onConfirm 
}) {
    const [editedTitle, setEditedTitle] = useState('');
    const [editedDescription, setEditedDescription] = useState('');

    useEffect(() => {
        if (idea) {
            setEditedTitle(idea.title || '');
            setEditedDescription(idea.description || '');
        }
    }, [idea]);

    const handleConfirm = () => {
        if (editedTitle.trim() && editedDescription.trim() && onConfirm) {
            onConfirm({
                id: idea.id,
                title: editedTitle.trim(),
                description: editedDescription.trim()
            });
            onHide();
        }
    };

    const handleCancel = () => {
        setEditedTitle(idea?.title || '');
        setEditedDescription(idea?.description || '');
        onHide();
    };

    const isDisabled = !editedTitle.trim() || !editedDescription.trim() || 
                     (editedTitle.trim() === idea?.title && editedDescription.trim() === idea?.description);

    return (
        <Modal 
            show={show} 
            onHide={handleCancel}
            centered
            backdrop="static"
            className="edit-idea-modal"
        >
            <Modal.Header closeButton className="edit-idea-modal-header">
                <Modal.Title>Editar Ideia</Modal.Title>
            </Modal.Header>
            
            <Modal.Body className="edit-idea-modal-body">
                <Input
                    label="Título"
                    placeholder="Digite o título da ideia"
                    mandatory={true}
                    value={editedTitle}
                    onChange={(e) => setEditedTitle(e.target.value)}
                />
                
                <TextArea
                    label="Descrição"
                    placeholder="Descreva a ideia em detalhes"
                    mandatory={true}
                    value={editedDescription}
                    onChange={(e) => setEditedDescription(e.target.value)}
                    maxLength={500}
                    textAreaStyle={{ minHeight: '120px' }}
                />
                
                <div className="character-count">
                    {editedDescription.length}/500 caracteres
                </div>
            </Modal.Body>
            
            <Modal.Footer className="edit-idea-modal-footer">
                <ButtonSecondary onClick={handleCancel}>
                    Cancelar
                </ButtonSecondary>
                <ButtonMain 
                    onClick={() => handleConfirm()}
                    disabled={isDisabled}
                >
                    Confirmar
                </ButtonMain>
            </Modal.Footer>
        </Modal>
    );
}